import CropIcon from './CropIcon';

export default CropIcon;
